import { render, staticRenderFns } from "./CampusActivities.vue?vue&type=template&id=aec32f24&scoped=true"
import script from "./CampusActivities.vue?vue&type=script&lang=js"
export * from "./CampusActivities.vue?vue&type=script&lang=js"
import style0 from "./CampusActivities.vue?vue&type=style&index=0&id=aec32f24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec32f24",
  null
  
)

export default component.exports